export default __webpack_public_path__ + "static/media/tryOver.81bc200c.png";